export default "__VITE_ASSET__BGQMapxh__"